module.exports = __webpack_public_path__ + "static/img/spinner.5c6bdb8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spinner.gif
// module id = rH7F
// module chunks = 1